import { twMerge } from 'tailwind-merge';
import { sortByUpdatedAt } from '@witmetrics/utils/arrays';
import { COLLECTION_VIEWS } from '@witmetrics/unison-core';
import { SkeletonListItem } from '@/components/List';
import FileItem from '../FileItem';
import FileCollectionItem from '../FileCollectionItem';
import type { BaseFileCollectionProps } from '../types';
import { DELAYS } from './constants';
import { classes } from './utils';

export interface FileCollectionListProps extends BaseFileCollectionProps {
  defaultExpanded?: boolean;
}

export default function FileCollectionList({
  defaultExpanded,
  isFetchingData,
  variant,
  className,
  fileCollections,
  files,
  onViewFileCollection,
  onViewFile,
  onDeleteFileCollection,
  onDeleteFile,
}: FileCollectionListProps) {
  if (isFetchingData) {
    return (
      <div className={twMerge(classes.section, className)}>
        <ul className={classes.list}>
          {DELAYS.map((delay) => (
            <SkeletonListItem key={delay} delay={delay} />
          ))}
        </ul>
      </div>
    );
  }
  return (
    <div className={twMerge(classes.section, className)}>
      <ul className={classes.list}>
        {sortByUpdatedAt(fileCollections!).map((fc) => (
          <FileCollectionItem
            key={`collection_${fc.id}`}
            showDetails
            defaultExpanded={defaultExpanded}
            fileCollectionId={fc.id}
            variant={variant}
            view={COLLECTION_VIEWS.LIST}
            onViewFile={onViewFile}
            onViewFileCollection={onViewFileCollection}
            onDelete={() => onDeleteFileCollection?.(fc.id)}
          />
        ))}
        {sortByUpdatedAt(files!).map((f) => (
          <FileItem
            key={`file_${f.id}`}
            showDetails
            fileId={f.id}
            variant={variant}
            view={COLLECTION_VIEWS.LIST}
            onSelect={onViewFile}
            onDelete={() => onDeleteFile?.(f.id)}
          />
        ))}
      </ul>
    </div>
  );
}
